<template>
  <el-dialog
    :title="'Welcome to AuthX'"
    :visible.sync="setShow"
    :close-on-click-modal="false"
    :show-close="false"
    width="28%"
  >
    <div>
      <div class="welcome">
        <img :src="getImage('welcome.svg')" alt="Welcome" />
      </div>
      <p>
        Thank you for being part of the first users. Radius is currently in a
        <strong>beta</strong> version and your feedback would be essential to
        us. Use the usersnap bot to get across to us.
      </p>
    </div>
    <span slot="footer">
      <el-button type="primary" size="medium" @click="setShow = false"
        >Proceed</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "ProductNotification",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    setShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      }
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.welcome {
  text-align: center;
  margin-bottom: 10px;

  img {
    height: 40px;
    width: auto;
  }
}
</style>
